import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function httpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  // Tie catalog requests to the deployed application so an older cached catalog
  // cannot hide newly deployed controls or leave their translation keys visible.
  return new TranslateHttpLoader(http, './assets/i18n/', '.json?app=' + encodeURIComponent(import.meta.url));
}
